import largeSubmittal from 'images/large-submittal.svg';
import React from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

const NoApprovedSubmittalFolders: React.VFC = () => {
  const { translate } = useTranslator(['submittalsPage']);

  return (
    <div className="column items-center mt7 mx3">
      <img
        src={largeSubmittal}
        alt="Large submittal illustration"
        className="b-radius-100 mb4"
      />
      <div className="size-20 bold black-1 mb2">
        {translate('submittalsPage:noApprovedSubmittals.title')}
      </div>
      <div className="size-16 black-2 center">
        {translate('submittalsPage:noApprovedSubmittals.description')}
      </div>
    </div>
  );
};

export default NoApprovedSubmittalFolders;
